import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from 'redux';

import userPreRegistrationReducer from './reducers/preRegistration';
import userReducer from "./reducers/user";
import usersReducer from "./reducers/users";
import optionsReducer from './reducers/options';
import courseReducer from './reducers/course';
import settingsReducer from './reducers/setting';
import paymentReducer from './reducers/payment';
import noticeMessageReducer from './reducers/noticeMessage';
import noteUserReducer from './reducers/noteUser';
import studentNotesReducer from './reducers/studentNotes';
import homeReducer from './reducers/home';
import requestReducer from './reducers/request';
import analyticsSlice from './reducers/analytics';
import chatRealtimeReducer from './reducers/chatRealtime';
import notificationsReducer from './reducers/notifications';
import zoomReducer from './reducers/zoom';
import tasksReducer from './reducers/tasks';
import calendarReducer from './reducers/calendar';

// Configuración de persist solo para el reducer de usuario
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'], // Solo persiste el estado de usuario
};

// Combinar todos los reducers
const rootReducer = combineReducers({
  user: userReducer,
  users: usersReducer,
  options: optionsReducer,
  preRegistration: userPreRegistrationReducer,
  course: courseReducer,
  setting: settingsReducer,
  payment: paymentReducer,
  noticeMessage: noticeMessageReducer,
  noteUser: noteUserReducer,
  studentNotes: studentNotesReducer,
  home: homeReducer,
  request: requestReducer,
  analytics: analyticsSlice,
  chatRealtime: chatRealtimeReducer,
  notifications: notificationsReducer,
  zoom: zoomReducer,
  tasks: tasksReducer,
  calendar: calendarReducer,
});

// Crear el reducer persistente
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Middleware personalizado para manejar valores no serializables
const nonSerializableMiddleware = getDefaultMiddleware => getDefaultMiddleware({
  serializableCheck: {
    ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
  },
});

export const Store = configureStore({
  reducer: persistedReducer,
  middleware: nonSerializableMiddleware
});

export const persistor = persistStore(Store);
